import { useTranslation } from "react-i18next";
import TitleWithTooltip from "src/common/components/TitleWithTooltip/TitleWithTooltip";

type Props = {
  media?: {
    id?: number | string;
    s3_url?: string;
    thumbnail_s3_url?: string;
    [key: string]: any;
  } | null;
  defaultMediaUrl?: string;
};

export const SourceAppMainMenuMedia360BackgroundSelectedForPublication = ({
  media,
  defaultMediaUrl,
}: Props) => {
  const { t } = useTranslation();

  const url = media?.s3_url || defaultMediaUrl;
  const isDefault = !media && !!defaultMediaUrl;

  return (
    <div className="flex flex-col items-center justify-center w-full gap-1">
      <TitleWithTooltip
        title={t("pages.projectGroup.publish.confirmationBeforePublish.selected360BackgroundImage")}
        tooltip={
          <span style={{ whiteSpace: "pre-line" }}>
            {`${t("tooltip.menuMedia360BackgroundExplanation")}\n${t(
              "tooltip.menuMedia360BackgroundExplanation2",
            )}`}
          </span>
        }
        className="text-lg font-semibold"
      />

      {url ? (
        <div className="relative w-40 h-32 bg-black rounded-xl border-4 border-green-500 overflow-hidden">
          <img
            src={url}
            alt="Menu 360 background"
            className="absolute inset-0 w-full h-full object-cover m-auto"
            loading="lazy"
          />
        </div>
      ) : (
        <div className="flex items-center justify-center w-40 h-32 bg-gray-100 rounded-xl border-2 border-dashed border-gray-400 text-gray-500">
          <span>{t("general.none")}</span>
        </div>
      )}

      {isDefault && (
        <div className="text-yellow-500 m-2 flex items-center text-center w-full">
          <h3 className="text-sm">⚠️ {t("tooltip.menuMediaDefaultFallback")}</h3>
        </div>
      )}
    </div>
  );
};

export default SourceAppMainMenuMedia360BackgroundSelectedForPublication;
